import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootElementId = Boolean(process.env.REACT_APP_ROOT_ELEMENT_ID)
  ? process.env.REACT_APP_ROOT_ELEMENT_ID
  : "embedded-homepage-category-cards";

const root = ReactDOM.createRoot(
  document.getElementById(rootElementId as string) as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
